import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlightClass } from '@websky/graphql';
import { ThemeProvider, useTheme } from '@websky/core/src/theme';
import { getDurationString } from '@websky/core/src/Results/utils';
import Segment from '@websky/core/src/Segment';
import theme from './PaymentHeader.css';
const PaymentHeader = ({ order }) => {
    const { t } = useTranslation('DesktopFlightInfo');
    const css = useTheme('SegmentOld').SegmentCommon;
    const segmentsTheme = {
        SegmentOld: {
            SegmentCommon: {
                wrapper: theme.wrapper,
                flightInfo__value: theme.flightInfo__value,
                city__info: theme.city__info,
                city__airport: theme.city__airport
            }
        }
    };
    if (!order) {
        return null;
    }
    const orderSegments = order.flight.segments.map(segment => {
        var _a;
        return ({
            id: segment.segment.id,
            marketingAirline: (_a = segment === null || segment === void 0 ? void 0 : segment.segment) === null || _a === void 0 ? void 0 : _a.marketingAirline,
            stops: [],
            flightNumber: segment.segment.flightNumber,
            operatingAirline: segment.segment.marketingAirline,
            departure: segment.segment.departure,
            arrival: segment.segment.arrival,
            fareFamilies: order.flight.segmentGroups.filter(group => group.groupId === segment.segment.id),
            checkinInfo: {
                webOpenTime: null,
                webCloseTime: null,
                airportOpenTime: null,
                airportCloseTime: null,
                boardingOpenTime: null,
                boardingCloseTime: null,
                checkinAvailable: null,
                cancelAvailable: null,
                airportHasDcs: false
            }
        });
    });
    const renderFooter = ({ segment }) => {
        var _a, _b, _c;
        const fareFamily = (_a = segment.fareFamilies[0]) === null || _a === void 0 ? void 0 : _a.fareFamily;
        const actualSegment = order.flight.segments.find(flightSegment => flightSegment.segment.id === segment.id);
        return (React.createElement("div", { className: css.footer },
            React.createElement("div", { className: css.footer__airline },
                React.createElement("span", null,
                    ((_b = fareFamily === null || fareFamily === void 0 ? void 0 : fareFamily.airline) === null || _b === void 0 ? void 0 : _b.icon) && (React.createElement("span", { className: css.airline__logo, style: {
                            backgroundImage: `url(${fareFamily.airline.icon})`
                        } })),
                    React.createElement("span", { className: theme.airline__name },
                        (fareFamily === null || fareFamily === void 0 ? void 0 : fareFamily.title) && `${(_c = fareFamily === null || fareFamily === void 0 ? void 0 : fareFamily.title) === null || _c === void 0 ? void 0 : _c.toLowerCase()},`,
                        " ",
                        t('Total duration'),
                        ' ',
                        React.createElement("span", null, getDurationString(actualSegment.segment.duration)))))));
    };
    return (React.createElement(ThemeProvider, { value: segmentsTheme },
        React.createElement("div", { className: theme.segments }, orderSegments.map(segment => {
            var _a, _b, _c, _d;
            return (React.createElement(Segment, { variant: "common", segment: segment, serviceClass: (_d = (_c = (_b = (_a = segment.fareFamilies) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.fareFamily) === null || _c === void 0 ? void 0 : _c.category) !== null && _d !== void 0 ? _d : FlightClass.Economy, renderFooter: renderFooter }));
        }))));
};
export default PaymentHeader;
